export enum IdCaptureMode {
  LOAD_MODEL = 'load_model',
  GET_MEDIA = 'get_media',
  RECORDING_STARTED = 'recording_started',
  IDLE = 'idle',
  DETECTING_READY = 'detecting_ready',
  DETECTING_STRAIGHT_ID = 'detecting_straight_id',
  COUNTDOWN_CAPTURE = 'countdown_capture',
  AWAITING_TILT_START = 'awaiting_tilt_start',
  DETECTING_TILT_LIVE = 'detecting_tilt_live',
  TILT_DETECTED = 'tilt_detected',
  DONE = 'done',
}
